import { raw, type Html } from "./html.ts";

/** General UI icons, drawn on the design's 16px grid at 1.75 stroke (they use `.ic` from screens.css). */
const PATHS = {
  runs: '<path d="M2.5 8a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0zM8 5v3l2 1.5"/>',
  files: '<path d="M2.5 3.5h4l1.5 1.5h5.5v7.5h-11z"/>',
  history: '<circle cx="4" cy="3.5" r="1.5"/><circle cx="4" cy="12.5" r="1.5"/><circle cx="12" cy="6" r="1.5"/><path d="M4 5v6M12 7.5c0 2.5-3 2.75-6.5 3.5"/>',
  agents: '<rect x="3" y="4.5" width="10" height="8" rx="3"/><path d="M8 4.5V2.5M6 8.5h.01M10 8.5h.01"/>',
  settings: '<circle cx="8" cy="8" r="2"/><path d="M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.4 3.4l1.4 1.4M11.2 11.2l1.4 1.4M3.4 12.6l1.4-1.4M11.2 4.8l1.4-1.4"/>',
  back: '<path d="M10 3L5 8l5 5"/>',
  arrow: '<path d="M3 8h10M9 4l4 4-4 4"/>',
  passkey: '<circle cx="5.5" cy="6.5" r="3"/><path d="M8.5 6.5h6M12.5 6.5v2.5M10.5 6.5v1.75"/>',
  git: '<circle cx="4" cy="3.5" r="1.75"/><circle cx="4" cy="12.5" r="1.75"/><circle cx="12" cy="6" r="1.75"/><path d="M4 5.25v5.5M12 7.75c0 2.5-3 2.75-6.5 3.5"/>',
} as const;

export type IconName = keyof typeof PATHS;

export function icon(name: IconName, size: 16 | 20 = 16): Html {
  return raw(`<svg class="ic${size === 20 ? " ic-20" : ""}" viewBox="0 0 16 16" aria-hidden="true" focusable="false">${PATHS[name]}</svg>`);
}
